import { useParams } from 'wouter'
import { useEffect, useMemo } from 'react'
import { useSuspenseQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

import { AddGoodies } from '@/features/layout'
import { useCloseModal } from '@/Router'
import { Suspense } from '@/components/ui/Suspense'
import useCategory from '@/features/layout/hooks/useCategory'
import { CheckPermission, Permission } from '@/features/auth'

function AddGoodiesToCategory({
  layoutVersion,
  slug
}: {
  layoutVersion: number
  slug: string
}) {
  const closeModal = useCloseModal()

  const { data } = useSuspenseQuery(AdminAPI.layout.GET_BY_VERSION, {
    variables: {
      version: layoutVersion
    },
    fetchPolicy: 'cache-and-network'
  })

  const layout = useMemo(
    () =>
      getFragment(SharedAPI.layout.LAYOUT_FRAGMENT, data.getLayoutByVersion),
    [data]
  )

  const { category } = useCategory(layout.id, slug)

  return (
    <div className="flex w-screen max-w-full flex-col gap-5 p-5">
      <AddGoodies category={category} onDone={closeModal} />
    </div>
  )
}

export default function AddGoodiesToCategorySuspense() {
  const closeModal = useCloseModal()
  const params = useParams() as { layoutVersion: string; slug: string }

  useEffect(() => {
    if (!params) closeModal()
  }, [closeModal, params])

  if (!params) return null

  return (
    <Suspense isDialog>
      <CheckPermission
        permissions={[Permission.LAYOUT_UPDATE]}
        onNoPermission={closeModal}
      >
        <AddGoodiesToCategory
          layoutVersion={parseInt(params.layoutVersion)}
          slug={params.slug}
        />
      </CheckPermission>
    </Suspense>
  )
}
